import { useEffect } from 'react';
import { useTourContext } from './tour-components';
import { useNavigate } from 'react-router-dom';

export default function TourDefinition() {
  const { addSteps } = useTourContext();
  const navigate = useNavigate();

  useEffect(() => {
    const crossPageSteps = [
      // Homepage steps
      // {
      //   selector: '.welcome-section',
      //   content: "Welcome to our app! Let's take a quick tour.",
      //   position: 'center' as const,
      //   // page: '/',
      //   disableBeacon: true
      // },
      // {
      //   selector: '.get-started-btn',
      //   content: 'Click here to get started with your dashboard.',
      //   position: 'bottom' as const
      //   // page: '/'
      // },

      // Side nav steps
      {
        selector: '#map',
        content:
          'Sort stakeholders by category in seconds — spot key players, align your team, and drive smarter decisions',
        position: 'right' as const,
        page: '*',
        disableBeacon: true
      },
      {
        selector: '#map-categories',
        content:
          'Start mapping in seconds: Choose a category and watch the map build itself',
        position: 'right' as const,
        page: '/dashboard/map',
        disableBeacon: false,
        navigationDelay: 300 // Wait for UI to settle
      },
      {
        selector: '#change-view',
        content:
          'Click this icon to switch between the visual map and an alphabetical table of stakeholders and chosen category.',
        position: 'right' as const,
        page: '/dashboard/map',
        disableBeacon: false
      },
      {
        selector: '#map-filter',
        content:
          'Need clarity? Filter your map to spotlight stakeholders and categories that match your goals.',
        position: 'right' as const,
        page: '/dashboard/map',
        disableBeacon: false
      },

      // Organizations section
      {
        selector: '#organizations',
        content:
          'Your stakeholder directory! Search, sort, or export data instantly to find key players, track priorities, or share insights.',
        position: 'right' as const,
        page: '*',
        disableBeacon: false
      },
      // {
      //   selector: '#organizations-view-profile',
      //   content:
      //     'Complete stakeholder profile at a glance! Verified stakeholders (✓) have personally confirmed their details for accuracy.',
      //   position: 'right' as const,
      //   page: '/dashboard/organizations',
      //   disableBeacon: false,
      //   navigationDelay: 500
      // },
      // {
      //   selector: '#recommend-organization',
      //   content:
      //     'Recommend geospatial stakeholders in LMICs to empower their work.',
      //   position: 'right' as const,
      //   page: '/dashboard/organizations',
      //   disableBeacon: false
      // },

      // Projects section
      {
        selector: '#projects',
        content:
          'Explore projects in action! Track ongoing work and results — all shared directly by stakeholders to showcase their impact.',
        position: 'right' as const,
        page: '*',
        disableBeacon: false
      },
      // {
      //   selector: '#view-projects',
      //   content:
      //     'Discover comprehensive project information and learn what matters.',
      //   position: 'right' as const,
      //   page: '/dashboard/projects',
      //   disableBeacon: false
      // },
      // {
      //   selector: '#add-projects',
      //   content:
      //     'Add a completed or ongoing project here so stakeholders can view your work, learn from your experience, and collaborate with you.',
      //   position: 'right' as const,
      //   page: '/dashboard/projects',
      //   disableBeacon: false
      // },

      // Set up section
      {
        selector: '#set-up',
        content:
          'Update your profile details here to keep your information current.',
        position: 'right' as const,
        page: '*',
        disableBeacon: false
      },
      // {
      //   selector: '#set-up-settings',
      //   content:
      //     'Manage your profile here: change your password, update your details, or disable/delete your profile',
      //   position: 'right' as const,
      //   page: '/dashboard/settings',
      //   disableBeacon: false
      // },

      // Help section
      {
        selector: '#help',
        content:
          'For support or inquiries, reach out to us here and we will get back to you promptly.',
        position: 'right' as const,
        page: '*',
        disableBeacon: false
      }
    ];

    const enhancedSteps = crossPageSteps.map((step) => ({
      ...step,
      callback: (data: any) => {
        if (data.action === 'next' || data.action === 'start') {
          // Navigate to the step's page if not already there
          if (
            step.page &&
            step.page !== '*' &&
            step.page !== window.location.pathname
          ) {
            navigate(step.page);
            // Return false to pause the tour until navigation completes
            return false;
          }
        }
        return true;
      }
    }));

    addSteps(enhancedSteps);
  }, [addSteps, navigate]);

  return null;
}
